const ArraySoal = {
    idProfilCbt:null,
    idSubProfilCbt:null,
    arraySoal:[]
};

export default ArraySoal;